"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSecurityPanel = void 0;
var accountsecurity_cms_1 = require("../components/AccountSecurity/accountsecurity.cms");
var AccountSecurityPanel = /** @class */ (function () {
    function AccountSecurityPanel() {
        this.panelContent = new accountsecurity_cms_1.AccountSecurityCms();
    }
    return AccountSecurityPanel;
}());
exports.AccountSecurityPanel = AccountSecurityPanel;
//# sourceMappingURL=AccountSecurityPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/AccountSecurityPanel.cms.js
// module id = 2018
// module chunks = 8